export const translations = {
  name: {
    pt: 'Nome da rota',
    en: 'Route name',
    es: 'Nombre de la ruta',
    de: 'Routenname',
  },
  carrier: {
    pt: 'Transportadora',
    en: 'Carrier',
    es: 'Transportista',
    de: 'Spediteur',
  },
  generalCompany: {
    pt: 'Centro',
    en: 'Center',
    es: 'Centro',
    de: 'Zentrum',
  },
  freightReturn: {
    pt: 'Frete retorno?',
    en: 'Freight return?',
    es: '¿Flete de retorno?',
    de: 'Fracht Rückgabe?',
  },
  forwardTripOnlyTitle: {
    pt: 'Origem/Destino',
    en: 'Origin/Destination',
    es: 'Origen/Destino',
    de: 'Ursprung/Ziel',
  },
  forwardTripTitle: {
    pt: 'Origem/Destino ida',
    en: 'Origin/Destination forward',
    es: 'Origen/Destino ida',
    de: 'Ursprung/Ziel Hinweg',
  },
  backwardTripTitle: {
    pt: 'Origem/Destino volta',
    en: 'Origin/Destination return',
    es: 'Origen/Destino vuelta',
    de: 'Ursprung/Ziel Rückweg',
  },
};